module.exports = __webpack_public_path__ + "img/72600.5dbac5ce.jpg";